export const hasNestedCategory = (category: string): boolean =>
  (String(category) || '').includes(':');

export default hasNestedCategory;
